<template>
<div v-if="isShow">
    <div class="h-right" style="margin-top: 16px">
        <a @click="$emit('closeMemo')"><img src="~@/assets/images/icon01.svg" /></a>
    </div>
    <div class="txt-area">
        <p class="b">{{ userInfo.display_name }}</p>
    </div>
    <div class="real-select">
        <select v-model="categoryId" :class="categoryError && 'errorInput'" @change="categoryError = false">
            <option :value="null" disabled hidden>選択してください</option>
            <option v-for="(item, index) in categories" :value="index" :key="item">{{ item }}</option>
        </select>
        <p v-if="categoryError" class="errorMsg">エラーです</p>
    </div>
    <div class="txt-area">
        <p class="b">メモ</p>
        <textarea v-model="content" class="self-introduction1" placeholder="お相手の情報をメモしよう" :maxlength="maxLength">
お相手情報をメモしよう
</textarea>
        <div class="clearfix">

            <div class="self-introduction3">{{lengthContent}}/{{maxLength}}</div>
        </div>

        <p>※メモの内容はお相手には見えません。</p>
        <p>※メモはいつでも編集・削除ができます。</p>

    </div>
    <div class="btn9"><a @click="submit">保存</a></div>
</div>
</template>

<script>
export default {
    props: {
        isShow: Boolean,
        userInfo: Object
    },
    data: () => ({
        content: '',
        categoryId: null,
        categoryError: false,
        maxLength: 500
    }),
    computed: {
        categories() {
            const categories = {...this.$store.getters.metadata.memo_category}
            delete categories[1]; 

            return categories
        },
        lengthContent() {
            if (this.content)
                return this.content.length

            return 0
        }
    },
    mounted() {
    },
    methods: {
        submit() {
            if (this.validate()) return;
            
            this.$emit('submit', {
                categoryId: this.categoryId,
                content: this.content,
                userId: this.userInfo.id
            })
        },
        validate() {
            if (!this.categoryId) {
                this.categoryError = true
                return true
            }
            return false
        }
    }
}
</script>

<style scoped>
.errorInput {
    border-color: red;
}
.errorMsg {
    color: red;
    margin-left: 3%;
}
.real-select select {
    margin: 3%;
    width: 94%;
}
</style>
